import type { ReactNode } from "react";

interface Props {
  children: ReactNode;
  color?: string;       // hex tematico (override completo)
  variant?: "solid" | "outline";
  className?: string;
}

export function Badge({
  children,
  color = "#2C5F8A",
  variant = "solid",
  className = "",
}: Props) {
  const style =
    variant === "solid"
      ? { backgroundColor: color, color: "#fff" }
      : { borderColor: color, color };
  return (
    <span
      style={style}
      className={`
        inline-block rounded-full px-3 py-1 text-xs font-mono uppercase tracking-wider
        ${variant === "outline" ? "border bg-transparent" : ""}
        ${className}
      `}
    >
      {children}
    </span>
  );
}
